import * as React from "react";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
} from "@mui/material";
import Button from "@mui/material/Button";
import {toast} from "react-toastify";
import {gql} from "@apollo/client";
import LoadingDialog from "../../components/loadingDialog";
import {mutate} from "../../lib/apollo";
import TextField from "@mui/material/TextField";

export default function ClickWallTimecard (params: {timecard: any, setTimecard: any, reload: any}) {
    const [loading, setLoading] = React.useState(true);
    const [hours, setHours] = React.useState(0);
    const [minutes, setMinutes] = React.useState(0);

    React.useEffect(() => {
        setLoading(false);
    }, []);

    React.useEffect(() => {
        if (params.timecard) {
            let seconds = params.timecard.seconds || 0;
            let hours = Math.floor(seconds / 3600);
            let minutes = Math.floor((seconds % 3600) / 60);
            setHours(hours);
            setMinutes(minutes);
        } else {
            setMinutes(0);
            setHours(0);
        }
    }, [params.timecard.agent]);

    const handleClose = (event?: any, reason?: any) => {
        if (reason && reason == "backdropClick")
            return;
        params.setTimecard({agent: '', seconds: 0, date: ''});
    };

    const handleSubmit = async (event: any) => {
        let seconds = hours * 3600 + minutes * 60;

        const q = gql`
            mutation m($agent: String!, $date: String!, $seconds: Int!) {
                clickWallSetHours(agent: $agent, date: $date, seconds: $seconds)
            }
        `;

        const variables = {
            agent: params.timecard.agent,
            date: params.timecard.date,
            seconds
        };

        setLoading(true);

        const res = await mutate(q, variables);
        const good = res && res.clickWallSetHours;

        if (good) {
            toast.success('Time Card Updated Successfully');
            setLoading(false);
            handleClose();
            params.reload();
        } else {
            setLoading(false);
        }
    }

    if (!params.timecard.agent) return <> </>;

    return (
        <>
                <Dialog
                    open={!!params.timecard.agent}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    maxWidth={'sm'}
                    fullWidth={true}
                >
                    <DialogTitle id="alert-dialog-title">
                        Update Time Card: {params.timecard.agent} ({params.timecard.date})
                    </DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <TextField
                                    autoComplete={'off'}
                                    margin="dense"
                                    id="hours"
                                    label="Hours"
                                    type="number"
                                    fullWidth
                                    size={'small'}
                                    value={hours}
                                    onChange={(e) => setHours(parseInt(e.target.value || "0"))}
                                    inputProps={{
                                        step: "1"
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    autoComplete={'off'}
                                    margin="dense"
                                    id="minutes"
                                    label="Minutes"
                                    type="number"
                                    fullWidth
                                    size={'small'}
                                    value={minutes}
                                    onChange={(e) => setMinutes(parseInt(e.target.value || "0"))}
                                    inputProps={{
                                        step: "1"
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    {loading ? <LoadingDialog/> :
                    <DialogActions>
                        <Button sx={{color: 'red'}} onClick={handleClose}>Close</Button>
                        <Button sx={{color: 'green'}} onClick={handleSubmit} autoFocus>Set</Button>
                    </DialogActions>
                    }
                </Dialog>
        </>
    )
}
